<script lang="ts">
	import { onMount } from 'svelte';

	let x = $state(0);
	let y = $state(0);
	let visible = $state(false);

	onMount(() => {
		let pendingX = 0;
		let pendingY = 0;
		let rafId = 0;

		const updatePosition = () => {
			x = pendingX;
			y = pendingY;
			if (!visible) visible = true;
			rafId = 0;
		};

		const handleMouseMove = (e: MouseEvent) => {
			pendingX = e.clientX;
			pendingY = e.clientY;
			if (!rafId) {
				rafId = requestAnimationFrame(updatePosition);
			}
		};

		const handleMouseLeave = () => {
			visible = false;
		};

		const handleMouseEnter = () => {
			visible = true;
		};

		document.addEventListener('mousemove', handleMouseMove);
		document.addEventListener('mouseleave', handleMouseLeave);
		document.addEventListener('mouseenter', handleMouseEnter);

		return () => {
			cancelAnimationFrame(rafId);
			document.removeEventListener('mousemove', handleMouseMove);
			document.removeEventListener('mouseleave', handleMouseLeave);
			document.removeEventListener('mouseenter', handleMouseEnter);
		};
	});
</script>

<div
	class="cursor-glow"
	aria-hidden="true"
	style="
		left: {x}px;
		top: {y}px;
		opacity: {visible ? 1 : 0};
	"
></div>

<style>
	.cursor-glow {
		position: fixed;
		width: 600px;
		height: 600px;
		pointer-events: none;
		z-index: 0;
		transform: translate(-50%, -50%);
		background: radial-gradient(
			circle,
			rgba(139, 92, 246, 0.06) 0%,
			rgba(59, 130, 246, 0.03) 30%,
			transparent 70%
		);
		filter: blur(40px);
		transition: opacity 0.5s cubic-bezier(0.25, 1, 0.5, 1);
		will-change: left, top;
	}

	@media (prefers-reduced-motion: reduce) {
		.cursor-glow {
			display: none;
		}
	}
</style>
